import * as React from 'react';


export const Loading = () => {
    return (
        <div className="loading-shell">
            <span className="loading-label">Loading</span>
        </div>
    );
};
